import camelCase from 'lodash/camelCase'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import reduce from 'lodash/reduce'

export const camelCaseKeys = obj => {
  if (!isObject(obj)) {
    return obj
  }
  if (isArray(obj)) {
    return obj.map(v => camelCaseKeys(v))
  }
  return reduce(
    obj,
    (r, v, k) => {
      return {
        ...r,
        [camelCase(k)]: camelCaseKeys(v),
      }
    },
    {}
  )
}

// https://trpc.io/docs/v9/error-handling#error-codes
const trpcErrorCodes = {
  400: 'BAD_REQUEST',
  401: 'UNAUTHORIZED',
  403: 'FORBIDDEN',
  404: 'NOT_FOUND',
  405: 'METHOD_NOT_SUPPORTED',
  408: 'TIMEOUT',
  409: 'CONFLICT',
  412: 'PRECONDITION_FAILED',
  413: 'PAYLOAD_TOO_LARGE',
  499: 'CLIENT_CLOSED_REQUEST',
  500: 'INTERNAL_SERVER_ERROR',
}

export const getTRPCErrorCode = httpCode => {
  return trpcErrorCodes[httpCode] || 'INTERNAL_SERVER_ERROR'
}
